module.exports = __webpack_public_path__ + "img/gc_country_flag_at.2847c576.svg";